export default {
  soregies: "Sorégies",
  alterna: "Alterna énergie",
  autre: "Autre fournisseur",
};
